module.exports = __webpack_public_path__ + "img/Pic_LT_I.7acfdf09.png";